<template>
  <div>
    <transition name="modal">
      <diet-modal
        v-if="showDietDetail"
        :diet="diet"
        @close="showDietDetail = false"
        @printMeal="printMeal"
        @printAllMeals="printAllMeals"
      ></diet-modal>
    </transition>

    <div class="card-bordered w-full">
      <div class="flex justify-between items-center">
        <p class="font-medium">ID: #{{ diet.id }} - {{ diet.name }}</p>
        <div class="flex items-center">
          <div class="flex space-x-2">
            <button
              class="secondary-button"
              @click.prevent="showDietDetail = true"
            >
              Detalle
            </button>
          </div>
        </div>
      </div>

      <p v-if="diet.status === 'excluded'" class="text-error-500 mt-2 text-sm">
        Esta dieta está excluída del plan actualemente.
      </p>
    </div>
  </div>
</template>

<script>
import DietModal from "../modals/DietModal";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
import api from "@/api";
export default {
  name: "Diet",

  components: {
    DietModal,
  },

  props: {
    diet: Object,
  },

  data() {
    return {
      loadingChange: false,
      loadingDelete: false,
      previousStateToView: null,
      showDietDetail: false,
    };
  },

  created() {
    this.selectedDietId = this.diet.id;
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    prepareDietFormat() {
      let dietFormatted = JSON.parse(JSON.stringify(this.diet));

      dietFormatted.meals.forEach((meal) => {
        meal.portions.forEach((portion) => {
          portion.diet_category_id = portion.diet_subcategory.diet_category_id;
          portion.saved = true;

          delete portion.id;
          delete portion.meal_id;
          delete portion.meal_id;
          delete portion.diet_subcategory;
          delete portion.created_at;
          delete portion.updated_at;
        });

        delete meal.id;
        delete meal.diet_id;
        delete meal.created_at;
        delete meal.updated_at;
      });

      delete dietFormatted.collapsed;
      delete dietFormatted.created_at;
      delete dietFormatted.updated_at;
      delete dietFormatted.diet_stage;
      delete dietFormatted.diet_type;
      delete dietFormatted.quote_id;

      return dietFormatted;
    },

    async printMeal(mealId) {
      try {
        const response = await api.diets.printMeal(mealId);
        this.$store.dispatch("successSnack", response.message);
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
    },

    async printAllMeals() {
      try {
        const response = await api.diets.printAllMeals(this.diet.id);
        this.$store.dispatch("successSnack", response.message);
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
    },
  },
};
</script>